import React from "react";
import { useParams } from "react-router-dom";
import NotFound from "../../404";
import studycase from "./Studycase.module.css"
import BackButton from "../../components/studycase/BackButton";
import NavBar from "../../components/studycase/navbar/NavBar";
import StudyCasesData from "../../data/StudycasesData";
import { Logo } from "../../components/icons/all-icons";

function Studycase() {
    const { slug } = useParams(); 
    const caseData = StudyCasesData[slug];

    if (!caseData) {
        return <NotFound replace />;
    }

    const hasWebsite = caseData?.navBar?.hasWebsite ?? true; 
    const websiteLink = caseData?.navBar?.websiteLink || "/";

    return (
        <main id={studycase.studycase}>
            <section id="hero" className={studycase.hero}>
                <h1 className={studycase.H1}>
                    {caseData?.hero?.slogan.split(caseData?.hero?.highlightText).map((part, index, arr) => (
                        <React.Fragment key={index}>
                            {part}
                            {index < arr.length - 1 && (
                                <span style={{ color: caseData?.colors?.primary}}>
                                    {caseData?.hero?.highlightText}
                                </span>
                            )}
                        </React.Fragment>
                    ))}
                </h1>
                <div className={studycase.moving}>
                    <ul>
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                    </ul>
                    <ul aria-hidden="true">
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                        <p>{caseData?.hero?.h1}</p>
                        <Logo className={studycase.logo}/>
                    </ul>
                </div>
                
            </section>
            <section id="introduction" className={studycase.introduction}>
                <div className={studycase.generalInfo}>
                    <div className={studycase.infos}>
                        <h3>MY ROLES</h3>
                        <div className={studycase.tags}>
                            {caseData?.introduction?.roles?.map((role, index) => (
                                <div key={index} className={studycase.tag}>
                                    <p>{role}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={studycase.infos}>
                        <h3>DELIBERABLES</h3>
                        <div className={studycase.tags}>
                            {caseData?.introduction?.deliberables?.map((role, index) => (
                                <div key={index} className={studycase.tag}>
                                    <p>{role}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={studycase.infos}>
                        <h3>TEAM</h3>
                        <div className={studycase.tags}>
                            {caseData?.introduction?.team?.map((role, index) => (
                                <div key={index} className={studycase.tag}>
                                    <p>{role}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={studycase.infos}>
                        <h3>YEAR</h3>
                        <p>{caseData?.introduction?.year}</p>
                    </div>
                </div>
                <div className={studycase.info}>
                    <div className={studycase.company}>
                        <h1>WHO?</h1>
                        <p>{caseData?.introduction?.who}</p>
                    </div>
                    <div className={studycase.company}>
                        <h1>WHAT?</h1>
                        <p>{caseData?.introduction?.what}</p>
                    </div>
                </div>
                <img src={caseData?.introduction?.iMacMockup} alt="Website Mockup" loading="lazy"/>
            </section>
            <section id="problems" className={studycase.problems}>
                <div className={studycase.challenge}>
                    <div className={studycase.allChallenges}>
                        <h1>CHALLENGE</h1>
                        <div className={studycase.cards}>
                            <div className={studycase.activeCard} style={{color: caseData?.colors?.primary}}>
                                <h2>01</h2>
                                <p>{caseData?.problems?.problem1?.title}</p>
                            </div>
                            <div className={studycase.card}>
                                <h2>02</h2>
                                <p>{caseData?.problems?.problem2?.title}</p>
                            </div>
                            <div className={studycase.card}>
                                <h2>03</h2>
                                <p>{caseData?.problems?.problem3?.title}</p>
                            </div>
                        </div>
                    </div>
                    <div className={studycase.description}>
                        <img src={caseData?.problems?.iPhoneWebsite} alt="iPhoneWebsite" style={{display: caseData?.problems?.problem1?.mockupDisplay}} loading="lazy"/>
                        <div className={`${studycase.container} ${
                            caseData?.problems?.problem1?.mockupDisplay === "flex" ? studycase.flexContainer 
                            : caseData?.problems?.problem1?.mockupDisplay === "none" ? studycase.noneContainer
                            : studycase.noneContainer }`
                        }>
                            <div className={studycase.content}>
                                <h1>THE PROBLEM</h1>
                                <p>{caseData?.problems?.problem1?.problemDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE SOLUTION</h1>
                                <p>{caseData?.problems?.problem1?.solutionDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE IMPACT</h1>
                                <p>{caseData?.problems?.problem1?.impactDescription}</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className={studycase.challenge}>
                    <div className={studycase.allChallenges}>
                        <h1>CHALLENGE</h1>
                        <div className={studycase.cards}>
                            <div className={studycase.card}>
                                <h2>01</h2>
                                <p>{caseData?.problems?.problem1?.title}</p>
                            </div>
                            <div className={studycase.activeCard} style={{color: caseData?.colors?.primary}}>
                                <h2>02</h2>
                                <p>{caseData?.problems?.problem2?.title}</p>
                            </div>
                            <div className={studycase.card}>
                                <h2>03</h2>
                                <p>{caseData?.problems?.problem3?.title}</p>
                            </div>
                        </div>
                    </div>
                    <div className={studycase.description}>
                        <img src={caseData?.problems?.iPhoneWebsite} alt="iPhoneWebsite" style={{display: caseData?.problems?.problem2?.mockupDisplay}} loading="lazy"/>
                        <div className={`${studycase.container} ${
                            caseData?.problems?.problem2?.mockupDisplay === "flex" ? studycase.flexContainer 
                            : caseData?.problems?.problem2?.mockupDisplay === "none" ? studycase.noneContainer
                            : studycase.noneContainer }`
                        }>
                            <div className={studycase.content}>
                                <h1>THE PROBLEM</h1>
                                <p>{caseData?.problems?.problem2?.problemDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE SOLUTION</h1>
                                <p>{caseData?.problems?.problem2?.solutionDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE IMPACT</h1>
                                <p>{caseData?.problems?.problem2?.impactDescription}</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className={studycase.challenge}>
                    <div className={studycase.allChallenges}>
                        <h1>CHALLENGE</h1>
                        <div className={studycase.cards}>
                            <div className={studycase.card}>
                                <h2>01</h2>
                                <p>{caseData?.problems?.problem1?.title}</p>
                            </div>
                            <div className={studycase.card}>
                                <h2>02</h2>
                                <p>{caseData?.problems?.problem2?.title}</p>
                            </div>
                            <div className={studycase.activeCard} style={{color: caseData?.colors?.primary}}>
                                <h2>03</h2>
                                <p>{caseData?.problems?.problem3?.title}</p>
                            </div>
                        </div>
                    </div>
                    <div className={studycase.description}>
                        <div className={`${studycase.container} ${
                            caseData?.problems?.problem3?.mockupDisplay === "flex" ? studycase.flexContainer 
                            : caseData?.problems?.problem3?.mockupDisplay === "none" ? studycase.noneContainer 
                            : studycase.noneContainer }`
                        }>
                            <div className={studycase.content}>
                                <h1>THE PROBLEM</h1>
                                <p>{caseData?.problems?.problem3?.problemDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE SOLUTION</h1>
                                <p>{caseData?.problems?.problem3?.solutionDescription}</p>
                            </div>
                            <div className={studycase.content}>
                                <h1>THE IMPACT</h1>
                                <p>{caseData?.problems?.problem3?.impactDescription}</p>
                            </div>
                        </div>
                    </div>
                    <div className={studycase.mockups}>
                        <img src={caseData?.problems?.macMockup} alt="macMockup" loading="lazy"/>
                        <img src={caseData?.problems?.iPhoneMockup} alt="iPhoneMockup" loading="lazy"/>
                    </div>
                </div>
            </section>
            <section id="system" className={studycase.system}>
                <h1>{caseData?.system?.companyName} BRAND SYSTEM</h1>
                <div className={studycase.brandSystem}>
                    <div className={studycase.mobileLogo} style={{backgroundColor: caseData?.colors?.light}}><img src={caseData?.system?.mobileLogo} alt="Company Mobile Logo" loading="lazy"/></div>
                    <div className={studycase.desktopLogo} style={{backgroundColor: caseData?.colors?.light}}><img src={caseData?.system?.desktopLogo} alt="Company Desktop Logo" loading="lazy"/></div>
                    <div className={studycase.fonts}>
                        {caseData?.system?.fonts?.map((font, index) => (
                            <div key={index} className={studycase.font}>
                                <h1 style={{ fontFamily: font, "-webkit-text-stroke-color": caseData?.colors?.light}}>Aa</h1>
                                <p style={{ fontFamily: font, color: caseData?.colors?.light}}>{font}</p>
                            </div>
                        ))}
                    </div>
                    <div className={studycase.colors}>
                        {caseData?.system?.colors?.map((color, index) => {
                            // Convert Hex to RGB to determine brightness
                            const hexToRgb = (hex) => {
                                const bigint = parseInt(hex.slice(1), 16);
                                const r = (bigint >> 16) & 255;
                                const g = (bigint >> 8) & 255;
                                const b = bigint & 255;
                                return { r, g, b };
                            };

                            const getBrightness = (hex) => {
                                const { r, g, b } = hexToRgb(hex);
                                return (r * 0.299 + g * 0.587 + b * 0.114); // Perceived brightness formula
                            };

                            // Find the darkest and lightest colors
                            const sortedColors = [...caseData?.system?.colors].sort((a, b) => getBrightness(a) - getBrightness(b));
                            const darkestColor = sortedColors[0]; // Darkest color in array
                            const lightestColor = sortedColors[sortedColors.length - 1]; // Lightest color in array

                            // Choose text color based on brightness
                            const textColor = getBrightness(color) > 128 ? darkestColor : lightestColor;

                            return (
                                <div key={index} className={studycase.color} style={{ backgroundColor: color }}>
                                    <p style={{ color: textColor }}>{color}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>


            </section>
            <section id="leaning" className={studycase.learning}>
                <h1>FINAL DESIGN & LESSON LEARNED</h1>
                <div className={studycase.websiteLearning}>
                    <div className={studycase.desktopLearning}>
                        <div className={studycase.end}>
                            <div className={studycase.lesson}>
                                <div className={studycase.info}>
                                    <div className={studycase.finalInfo}>
                                        <h1>HOW?</h1>
                                        <p>{caseData?.learning?.how}</p>
                                    </div>
                                    <div className={studycase.finalInfo}>
                                        <h1>OUTCOME</h1>
                                        <p>{caseData?.learning?.outcome}</p>
                                    </div>
                                </div>
                                <div className={studycase.finalLesson}>
                                    <h1>THE FINAL LESSON</h1>
                                    <p>{caseData?.learning?.finalLesson}</p>
                                </div>
                            </div>
                            <div className={studycase.metrics}>
                                {caseData?.learning?.metrics?.map((item, index) => (
                                    <div key={index} className={studycase.metric}>
                                        <h1>{item.number}</h1>
                                        <p>{item.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <img style={{display: caseData?.learning?.desktopDisplay}} src={caseData?.learning?.desktopWebsite} alt="Desktop Website" className={studycase.desktopWebsite} loading="lazy"/>
                    </div>
                    <img style={{display: caseData?.learning?.mobileDisplay}} src={caseData?.learning?.mobileWebsite} alt="Mobile Website" className={studycase.mobileWebsite} loading="lazy"/>
                </div>
            </section>
            <BackButton/>
            <NavBar hasWebsite={hasWebsite} websiteLink={websiteLink} />
        </main>
    );
}

export default Studycase;

